import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_benefits",
  "use": "svg_benefits-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"svg_benefits\"><path d=\"m10 1.302 2.33 5.603a1 1 0 0 0 .844.613l6.05.485-4.61 3.948a1 1 0 0 0-.322.992l1.408 5.903-5.179-3.164a1 1 0 0 0-1.042 0l-5.18 3.164 1.409-5.903a1 1 0 0 0-.322-.992L.776 8.003l6.05-.485a1 1 0 0 0 .843-.613L10 1.302Z\" stroke=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol